<template>
	<div id="asssetComPage" class="page-navbar">
		   <mt-navbar class="page-part" v-model="selected">
				<mt-tab-item id="1">硬件信息</mt-tab-item>
			  	<mt-tab-item id="2">软件信息</mt-tab-item>
		   </mt-navbar>
		   
			<mt-tab-container v-model="selected">
			  <mt-tab-container-item id="1" v-if="isShow">
				<wc-assetchart :wareData="hardwareData" :id="id"></wc-assetchart>
			  </mt-tab-container-item>
			  <mt-tab-container-item id="2" v-else>
				<!--<wc-assetchart :wareData="softwareData"></wc-assetchart>-->
				<!--<div style="width=200px; height:200px; background: gold;"></div>-->
				<wc-assetchart :wareData="softwareData" :id="id"></wc-assetchart>
				<!--<wc-assetrt :wareData="softwareData"></wc-assetrt>-->
			  </mt-tab-container-item>
			</mt-tab-container>
	</div>
</template>

<script>
	
	export default{
		name:'WcAsset',
		data(){
			return {
				selected:'1',
				isShow:true,
				id:"myChart01"
			}
		},
		props:['hardwareData','softwareData'],
		methods:{
			aa(){
				//alert("dfadf");
			},
			onSwipeLeft(){
				this.selected="2";
			},
			onSwipeRight(){
				this.selected="1";
			}
		},
		watch:{
			selected: function (val, oldVal) {
		        // 这里就可以通过 val 的值变更来确定
		        if(val==1){
		        	this.isShow=true;
		        	this.id="myChart01";
		        }
		        if(val==2){
		        	this.isShow=false;
		        	this.id="myChart02";
		        }
		    }
		}
	}
</script>
	
<style>
	/* body{
		width: 100%;
		height: 100%;
	}
	#asssetComPage .mint-navbar .mint-tab-item.is-selected{
		margin-bottom: 0;
		color: #029CCE;
		border-bottom: 3px solid #029CCE;
	}
	#asssetComPage .mint-navbar .mint-tab-item{
		padding: 6px 0;
		border-bottom: 1px solid #D3D3D3;
	}
	#asssetComPage .mint-tab-item-label{
		height: 25px;
    	line-height: 25px;
    	border-right: 1px solid #D3D3D3;
		
	} */
	#asssetComPage .mint-tab-container-wrap{
		background: url(../../../assets/images/asset_bg.png) no-repeat;
		background-size: 100% 100%;
	}
	#asssetComPage .mint-tab-item-label{
		font-size:14px;
	}
</style>


// WEBPACK FOOTER //
// src/components/asset/asset/WcAsset.vue